import { render } from "./PopularRecipes.vue?vue&type=template&id=108272f0&scoped=true"
import script from "./PopularRecipes.vue?vue&type=script&lang=js"
export * from "./PopularRecipes.vue?vue&type=script&lang=js"

import "./PopularRecipes.vue?vue&type=style&index=0&id=108272f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108272f0"]])

export default __exports__